import { ApplicantStatus, Invitee } from "shared/types";
import { Applicant } from "types/application";

/**
 * Resolves the effective status of an applicant, taking into account
 * whether they are an actual applicant or an invitee with a pending magic link.
 */
export const getApplicantStatus = ({
  applicant,
  pendingMagicLink
}: {
  applicant: Applicant | Invitee;
  pendingMagicLink?: Invitee;
}): ApplicantStatus | undefined => {
  if ("verifications" in applicant) return applicant.application_status;

  const link = pendingMagicLink ?? applicant;
  if (link.active === false) return ApplicantStatus.Canceled;
  if (link.used !== true) return ApplicantStatus.Pending;
  return link.application_status;
};
